
import React from "react";
import StaticContentItem from "./StaticContentItem";
import { StaticContent } from "./useStaticText";

interface StaticContentListProps {
  filteredContents: StaticContent[];
  editingId: string | null;
  editedContent: string;
  setEditedContent: (content: string) => void;
  isSaving: boolean;
  handleEdit: (content: StaticContent) => void;
  handleCancelEdit: () => void;
  handleSave: (id: string) => void;
  searchTerm: string;
  selectedPage: string;
  selectedSection: string;
}

const StaticContentList: React.FC<StaticContentListProps> = ({
  filteredContents,
  editingId,
  editedContent,
  setEditedContent,
  isSaving,
  handleEdit,
  handleCancelEdit,
  handleSave,
  searchTerm,
  selectedPage,
  selectedSection
}) => {
  if (filteredContents.length === 0) {
    return (
      <div className="bg-white p-12 rounded-lg shadow text-center">
        <p className="text-gray-500">
          {searchTerm || selectedPage || selectedSection ? 
            "Nenhum texto encontrado com esses critérios" : 
            "Nenhum texto fixo disponível"}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4">
      {filteredContents.map(content => (
        <StaticContentItem
          key={content.id}
          content={content}
          editingId={editingId}
          editedContent={editedContent}
          setEditedContent={setEditedContent}
          isSaving={isSaving}
          handleEdit={handleEdit}
          handleCancelEdit={handleCancelEdit}
          handleSave={handleSave}
        />
      ))}
    </div>
  );
};

export default StaticContentList;
